export default __webpack_public_path__ + "static/media/BackgroundHotel.e3f044e2.jpg";